<style lang="scss" scoped>
.intel-sort {
  height: 20px;
  // margin-left: 20px;
  margin-left: 24px;
  &.sort-false {
    width: 84px;
    /deep/ .el-input__inner {
      color: rgb(92, 96, 117);
    }
    /deep/ .el-input {
      &::before {
        background-image: url("~@/assets/newicons/sort0.png");
      }
    }
  }
  &.sort-true {
    width: 141px;
  }

  /deep/ .el-input__inner {
    border: none;
    background: none;
    box-shadow: none;
    color: rgb(79, 122, 253);
    font-size: 14px;
  }
  /deep/ .el-input.is-focus .el-input__inner {
    border: none;
    background: none;
    box-shadow: none;
  }

  /deep/ .el-input__suffix {
    i {
      display: none;
    }
  }

  /deep/ .el-input {
    height: 20px;
    line-height: 20px;
    display: flex;
    align-items: center;

    input {
      // padding-left: 26px;
      flex: 1;
      height: 100%;
      padding: 0;
      margin-left: 6px;
      line-height: 20px;
    }
    &::before {
      content: " ";
      display: block;
      width: 20px;
      height: 20px;
      background-image: url("~@/assets/newicons/sort01.png");
      background-size: cover;
      background-position: center;
    }
  }
}
</style>
<template>
  <el-select :class="['intel-sort', 'sort-'+!!sortValue]" v-model="sortValue" @change="sortChange()">
    <el-option v-for="item in optionsTime" :key="item.value" :label="item.label" :value="item.value" />
  </el-select>
</template>
<script>
export default {
  props: {
    value: null,
    sortData: {
      type: Array,
      default: () => {
        return [
          { value: null, label: '智能排序' },
          { value: 'establishTime-1', label: '发布时间从早到晚' },
          { value: 'establishTime-2', label: '发布时间从晚到早' },
          { value: 'amount-2', label: '注册资产从高到低' },
          { value: 'amount-1', label: '注册资产从低到高' }
        ]
      }
    }
  },
  mounted() {
    this.optionsTime = this.sortData
    this.sortValue = this.value
  },
  data() {
    return {
      sortValue: null,
      optionsTime: null,
    }
  },
  methods: {
    sortChange() {
      if (!this.sortValue) {
        return this.$emit('sortChange', { sortField: null, sortType: null })
      }
      const [sortField, sortType] = this.sortValue.split('-')
      this.$emit('sortChange', { sortField, sortType: Number(sortType) })
    }
  }
}
</script>